import React, { Component } from 'react';

import {Button} from '@betareader/design-system';

// redux
import { push } from '../../navigation'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { withRouter } from 'react-router-dom';

// i18n
import { withTranslation } from 'react-i18next';

import FeedEvent from './feedEvent';
import { authUtil } from '../../utils';
import { PaddedWrapper } from '../../style';

export class BetaReaderFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feed: [],
      isLoading: false,
      isUpdating: false,
      hasMore: true
    };
  }

  componentDidMount() {
    this.getFeed();
  }

  componentWillUnmount() {
    this.feedObserver?.disconnect();
  }

  setLoadMoreSentinel = node => {
    this.feedObserver?.disconnect();
    if (!node || typeof IntersectionObserver === 'undefined') return;
    this.feedObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) this.updateFeed();
    }, {rootMargin: '10px'});
    this.feedObserver.observe(node);
  }

  getFeed = async () => {
    const idToken = await authUtil.getFreshIdToken();
    this.setState({
      isLoading: true
    }, () => {
      fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/feed`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken
        }
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(res.error);
          }
          return res.json();
        })
        .then((feed) => {
          if (feed) {
            this.setState({
              feed
            });
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.setState({
            isLoading: false
          });
        });
    });
  }

  updateFeed = () => {
    if (this.loadingMore || !this.state.hasMore) return;
    this.loadingMore = true;
    const { idToken } = this.props;
    const { feed } = this.state;
    this.setState({
      isUpdating: true
    }, () => {
      fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/feed?skip=${feed.length}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken
        }
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(res.error);
          }
          return res.json();
        })
        .then((moreFeed) => {
          if (moreFeed) {
            this.setState({
              feed: [...feed, ...moreFeed],
              hasMore: moreFeed.length > 0
            });
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingMore = false;
          this.setState({
            isUpdating: false
          });
        });
    });
  }

  render() {
    const { t } = this.props;
    const { feed, isUpdating, isLoading } = this.state;

    if (isLoading) {
      return <p role="status" aria-live="polite">{t('Loading', 'Loading…')}</p>;
    }

    const feedArray = feed.filter(event => !!event._id);

    if (feedArray.length === 0) {
      return (
        <PaddedWrapper>
          <p role="status">{t('NothingHere')}</p>
        </PaddedWrapper>
      );
    }
    return (
      <PaddedWrapper>
        <div className="br-feed-list" aria-label={t('Feed', 'Feed')}>
          {
            feedArray.filter(event => !!event._id)
              .map(event => (
                <FeedEvent
                  key={event._id}
                  event={event}
                />
              ))
          }
        </div>
        {
          this.state.hasMore && feed.length > 0 && !feed[feed.length - 1].isLast && (
            <div className="br-feed-list__more">
              <Button variant="secondary" onClick={this.updateFeed} disabled={isUpdating}>
                {isUpdating ? t('Loading', 'Loading…') : t('LoadMore')}
              </Button>
              <div ref={this.setLoadMoreSentinel} aria-hidden="true" />
            </div>
          )
        }
      </PaddedWrapper>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(BetaReaderFeed)));
